var api = require("!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/mini-css-extract-plugin/dist/loader.js??ref--5-oneOf-5-1!../../node_modules/css-loader/dist/cjs.js??ref--5-oneOf-5-2!../../node_modules/postcss-loader/dist/cjs.js??ref--5-oneOf-5-3!../../node_modules/resolve-url-loader/index.js??ref--5-oneOf-5-4!../../node_modules/sass-loader/dist/cjs.js??ref--5-oneOf-5-5!./style.scss");

            content = content.__esModule ? content.default : content;

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};